<template>
  <div class="myorders">
    <mainmenu selected="report-orders"></mainmenu>
    <div class="container-fluid">
      <h1>{{$t('report_order.page_title')}}</h1>
        <el-card class="box-card">
            <div slot="header" class="clearfix">
                <span>{{$t('report_order.filters')}}</span>
            </div>
            <div>
                <el-form :model="Filters">
                    <el-row  :gutter="10">
                      <el-col :md="8" :xs="12">
                        <el-form-item :label="$t('report_order.article_code')">
                          <el-autocomplete class="full-width"  v-model="Filters.ArticleCode" :fetch-suggestions="queryCodes"></el-autocomplete>
                        </el-form-item>
                      </el-col>

                      <el-col :md="8" :xs="12">
                        <el-form-item :label="$t('report_order.dates')">
                          <el-date-picker
                            class="full-width" 
                            v-model="Filters.Dates"
                            format="yyyy-MM-dd"
                            value-format="yyyy-MM-dd"
                            type="daterange"
                            align="right"
                            unlink-panels
                            range-separator="To"
                            start-placeholder="Start date"
                            end-placeholder="End date"
                            :picker-options="pickerOptions">
                          </el-date-picker>
                        </el-form-item>
                      </el-col>

                      <el-col :md="8" :xs="12">
                        <el-form-item :label="$t('report_order.category')">
                          <el-select v-model="Filters.IdCategory" class="full-width" >
                              <el-option :label="$t('report_order.all')" :value="-1" :key="-1"></el-option>
                              <el-option v-for="c in Categories" :label="c.Name" :value="c.Id" :key="c.Id"></el-option>
                          </el-select>
                        </el-form-item>
                      </el-col>
                    </el-row>
                    <el-row :gutter="10">
                      <el-col :span="8" :xs="12">
                        <el-form-item :label="$t('report_order.product_status')">
                            <el-select v-model="Filters.Status" class="full-width" >
                                <el-option :label="$t('report_order.all')" value="all"></el-option>
                                <el-option :label="$t('report_order.accepted')" value="accepted"></el-option>
                                <el-option :label="$t('report_order.rejected')" value="rejected"></el-option>
                                <el-option :label="$t('report_order.pending')" value="pending"></el-option>
                            </el-select>
                        </el-form-item>
                      </el-col>

                      <el-col :md="8" :xs="12">
                        <el-form-item :label="$t('report_order.buyer')">
                            <el-select v-model="Filters.IdBuyer" class="full-width" >
                                <el-option :label="$t('report_order.all')" :value="-1" :key="-1"></el-option>
                                <el-option v-for="u in AllUsers" :label="u.Name" :value="u.Id" :key="u.Id"></el-option>
                            </el-select>
                        </el-form-item>
                      </el-col>

                      <el-col :md="8" :xs="12">
                        <el-form-item :label="$t('report_order.seller')" class="full-width" >
                            <el-select v-model="Filters.IdSeller" class="full-width" >
                                <el-option :label="$t('report_order.all')" :value="-1" :key="-1"></el-option>
                                <el-option v-for="u in AllUsers" :label="u.Name" :value="u.Id" :key="u.Id"></el-option>
                            </el-select>
                        </el-form-item>
                      </el-col>

                      <el-col :span="24">
                        <el-form-item>
                            <el-button type="primary" @click="refresh_info">{{$t('report_order.filters')}}</el-button>
                            <el-button type="warning" @click="resetFilters">{{$t('report_order.reset')}}</el-button>

                            <a :href="$http.options.root + 'report_order/export_excel'" target="_blank" class="el-button pull-right el-button--success"> 
                              {{$t('report_order.excel')}}
                            </a>
                        </el-form-item>
                      </el-col>
                    </el-row>
                </el-form>
            </div>
        </el-card>

        <el-table :data="Results" style="width: 100%; margin-top: 50px" v-loading="tableLoadingVisible">
            <el-table-column prop="Id" :label="$t('report_order.unique_id')" width="60"></el-table-column>
            
            <el-table-column prop="RequestDate" :label="$t('report_order.request_date')" width="200"></el-table-column>

            <el-table-column prop="SellerFactoryCode" :label="$t('report_order.factory_code')" width="130"></el-table-column>
            <el-table-column prop="SellerName" :label="$t('report_order.seller_name')" width="130"></el-table-column>

            <el-table-column prop="BuyerFactoryCode" :label="$t('report_order.buyer_factory_code')" width="180"></el-table-column>
            <el-table-column prop="BuyerName" :label="$t('report_order.buyer_name')" width="130"></el-table-column>
            
            <el-table-column :label="$t('report_order.article_info')" width="200">
            <template slot-scope="scope">
                <strong>{{scope.row.ArticleNumber}}</strong> <br/>
                <em>{{scope.row.ProductCategory}}</em> <br/>
                <p class="small">{{scope.row.ProductDescription}}</p>
            </template>
            </el-table-column>

            <el-table-column :label="$t('report_order.product_status')" width="400">
            <template slot-scope="scope">
                <el-alert v-if="scope.row.RequestStatus=='accepted'" :title="$t('report_order.accepted')" type="success" :closable="false"></el-alert>
                <el-alert v-if="scope.row.RequestStatus=='pending'" :title="$t('report_order.pending')" type="warning" :closable="false"></el-alert>
                <el-alert v-if="scope.row.RequestStatus=='rejected'" :title="$t('report_order.rejected')" type="error" :closable="false"></el-alert>
                <el-alert v-if="scope.row.RequestStatus=='rejected'" :title="$t('report_order.reason') + ':' + scope.row.RejectReason" type="error" :closable="false"></el-alert>
            </template>
            </el-table-column>

            <el-table-column prop="Quantity" :label="$t('report_order.quantity')" width="100"></el-table-column>
            <el-table-column :label="$t('report_order.price')" width="120">
            <template slot-scope="scope">
                {{scope.row.Price|format_money}} &euro;
            </template>
            </el-table-column>
            <el-table-column fixed="right" :label="$t('report_order.operations')" width="180">
            <template slot-scope="scope">
                <div v-if="scope.row.RequestStatus=='accepted'">
                <a :href="scope.row.PdfDownloadUrl" target="_blank" class="button-link el-button el-button--success is-plain">
                    <i class="el-icon-download"></i>{{$t('report_order.download_delivery_note')}}
                </a>
                </div>
            </template>
            </el-table-column>
        </el-table>

      <el-pagination
          @size-change        = "refresh_info"
          @current-change     = "refresh_info"
          :page-size.sync     = "PaginationInfo.PerPage"
          :current-page.sync  = "PaginationInfo.Page"
          :total              = "PaginationInfo.RowCount"
          layout              = "pager">
      </el-pagination>


    </div>
  </div>
</template>

<script>
import MainMenu from "./../../widgets/MainMenu";
import settings from "./../../backend/LocalSettings";
import moment from 'moment';

export default {
  name: "report-orders",
  components: {
    "mainmenu": MainMenu
  },
  data () {
    return { 
      tableLoadingVisible: false,
      Results: [],
      Filters: { Dates:[ moment().format("YYYY-MM-DD"),moment().format("YYYY-MM-DD")] },
      PaginationInfo: { Page: 1, PerPage: 10, RowCount: 0, PageSizes: [10, 25, 50, 100] },
      Categories: [],
      Factories: [],
      AllUsers: [],
      pickerOptions: {
        shortcuts: [{
          text: 'Last week',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: 'Last month',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: 'Last 3 months',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      }
    }
  },
  methods: {
    resetFilters: function(){
        this.Filters =  { Dates:[ moment().format("YYYY-MM-DD"),moment().format("YYYY-MM-DD")], ArticleCode: "", IdCategory: -1, Status: "all", IdBuyer: -1, IdSeller: -1 };
        this.refresh_info();
    },
    get_info: function() {
      this.loadingVisible = true;
      this.$http
          .post('report_order/get_info',  {} )
          .then(function (response) {
            this.tableLoadingVisible = false;
            if( settings.verify_response(response, this.$rights)) {
              this.Categories = response.body.Categories;
              this.AllUsers   = response.body.AllUsers;
              this.refresh_info();
            } else {
              this.$router.push("/");
            }
          });  
    },
    refresh_info: function() {
      this.loadingVisible = true;
      this.$http
          .post('report_order/refresh_info',  { Filters: this.Filters, PaginationInfo: this.PaginationInfo } )
          .then(function (response) {
            this.tableLoadingVisible = false;
            if( settings.verify_response(response, this.$rights)) {
              this.Results = response.body.Results;
              this.PaginationInfo = response.body.PaginationInfo;
            } else {
              this.$router.push("/");
            }
          }); 
    },
    queryCodes: function(queryString, cb){
      this.loadingVisible = true;
      this.$http
          .post('products/search_code',  { query: queryString } )
          .then(function (response) {
            this.tableLoadingVisible = false;
            if( settings.verify_response(response, this.$rights)) {
              cb(response.body.Results);
            } else {
              this.$router.push("/");
            }
          }); 
    },
  },
  mounted: function() {
    this.resetFilters();
    this.get_info();
  }
};
</script>

<style lang="less" scoped>
  .el-form-item__label{
    display: block;
    float: none !important;
  }
  .button-link{
    text-decoration: none;
  }
  .full-width{
    width: 100% !important;
  }
</style>